import { Pagination as AntPagination } from 'antd';

const Component = (params: any) => {
  return <AntPagination showSizeChanger {...params} />;
};

export const Pagination = Component;
